import { render, staticRenderFns } from "./ImageEmptyLink.vue?vue&type=template&id=8630581c&scoped=true&"
import script from "./ImageEmptyLink.vue?vue&type=script&lang=js&"
export * from "./ImageEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8630581c",
  null
  
)

export default component.exports